import InventoryActions from './InventoryActions';

const {
  ADD,
  REMOVE,
  DAMAGED,
  SPOILED,
  FOUND_NEW,
  LOST,
  EXPIRED,
  STOLEN,
  DONATION_RECEIVED,
  DONATION_REMOVED,
  ORDER_RECEIVED,
  DONATED,
  ADD_CORRECTION,
  REMOVE_CORRECTION,
  PURCHASED,
  SOLD,
  DISTRIBUTION_RECEIVED,
  DISTRIBUTED,
  POS_ADD,
  POS_DEDUCT,
  POS_CANCELED
} = InventoryActions;

export const MainActionLabels = {
  [ADD]: 'Add',
  [REMOVE]: 'Deduct'
};

export const AddActionLabels = {
  [ADD]: 'New',
  [PURCHASED]: 'Purchased',
  [FOUND_NEW]: 'Found New',
  [ADD_CORRECTION]: 'Correction',
  [ORDER_RECEIVED]: 'Order Received',
  [DONATION_RECEIVED]: 'Donation Received',
  [DISTRIBUTION_RECEIVED]: 'Distribution Received',
  [POS_DEDUCT]: 'POS Deducted Order Item',
  [POS_CANCELED]: 'POS Canceled Order'
};

export const RemoveActionLabels = {
  [REMOVE]: 'Removed',
  [REMOVE_CORRECTION]: 'Correction',
  [DAMAGED]: 'Damaged',
  [DISTRIBUTED]: 'Distributed',
  [DONATED]: 'Donated',
  [DONATION_REMOVED]: 'Donation Removed',
  [EXPIRED]: 'Expired',
  [LOST]: 'Lost',
  [POS_ADD]: 'POS Added Order Item',
  [SOLD]: 'Sold',
  [SPOILED]: 'Spoiled',
  [STOLEN]: 'Stolen'
};
